// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__asfQq","rootNoMargin":"styles_rootNoMargin__2ybzA"};